import { render, staticRenderFns } from "./FileMultiple.vue?vue&type=template&id=56e6a1bf&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FileMultiple.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FileMultiple.vue
// module id = 2219
// module chunks = 1